module.exports = __webpack_public_path__ + "static/img/e5main.79c22df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/e5main.png
// module id = 0By+
// module chunks = 0